import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Deprecation } from 'deprecation';
import once from 'once';
var logOnceCode = once(function (deprecation) {
  return console.warn(deprecation);
});
var logOnceHeaders = once(function (deprecation) {
  return console.warn(deprecation);
});
/**
 * Error with extra properties to help with debugging
 */
var RequestError = /*#__PURE__*/function (_Error) {
  _inherits(RequestError, _Error);
  var _super = _createSuper(RequestError);
  function RequestError(message, statusCode, options) {
    var _this;
    _classCallCheck(this, RequestError);
    _this = _super.call(this, message);
    // Maintains proper stack trace (only available on V8)
    /* istanbul ignore next */
    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), _this.constructor);
    }
    _this.name = "HttpError";
    _this.status = statusCode;
    var headers;
    if ("headers" in options && typeof options.headers !== "undefined") {
      headers = options.headers;
    }
    if ("response" in options) {
      _this.response = options.response;
      headers = options.response.headers;
    }
    // redact request credentials without mutating original request options
    var requestCopy = Object.assign({}, options.request);
    if (options.request.headers.authorization) {
      requestCopy.headers = Object.assign({}, options.request.headers, {
        authorization: options.request.headers.authorization.replace(/ .*$/, " [REDACTED]")
      });
    }
    requestCopy.url = requestCopy.url
    // client_id & client_secret can be passed as URL query parameters to increase rate limit
    // see https://developer.github.com/v3/#increasing-the-unauthenticated-rate-limit-for-oauth-applications
    .replace(/\bclient_secret=\w+/g, "client_secret=[REDACTED]")
    // OAuth tokens can be passed as URL query parameters, although it is not recommended
    // see https://developer.github.com/v3/#oauth2-token-sent-in-a-header
    .replace(/\baccess_token=\w+/g, "access_token=[REDACTED]");
    _this.request = requestCopy;
    // deprecations
    Object.defineProperty(_assertThisInitialized(_this), "code", {
      get: function get() {
        logOnceCode(new Deprecation("[@octokit/request-error] `error.code` is deprecated, use `error.status`."));
        return statusCode;
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "headers", {
      get: function get() {
        logOnceHeaders(new Deprecation("[@octokit/request-error] `error.headers` is deprecated, use `error.response.headers`."));
        return headers || {};
      }
    });
    return _this;
  }
  return _createClass(RequestError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export { RequestError };